const NOTIFICATION_CLASS = 'portal-banner__right__bullet--display';
const PORTAL_BANNER = $('.portal-banner');
const SDS_VAULT_PATH = '/delegate/secure-document-store/v3/vaults';
const SEC_INBOX_REQ_PATH = '/delegate/secure-inbox/v4/mailboxes';

const checkDocumentNotif = (documentBadge: JQuery<HTMLElement>): void => {
  $.get(SDS_VAULT_PATH, (data: Array<{ commonObject: { id: number } }>) => {
    const vaults = data.map(vault => vault.commonObject.id);

    $.when(...vaults.map(vault => $.get(`${SDS_VAULT_PATH}/${vault}/documents/unread-count`))).done((...results) => {
      const unreadCount = vaults.length > 1 ? results.reduce((a, b) => a + b[0], 0) : results[0];
      if (unreadCount > 0) documentBadge.addClass(NOTIFICATION_CLASS);
    });
  });
};

const checkInboxNotif = (inboxBadge: JQuery<HTMLElement>): void => {
  $.get(`${SEC_INBOX_REQ_PATH}/users`, (users: Array<{ id: string }>) => {
    const inboxes = users.map(user => user.id);

    $.when(...inboxes.map(inbox => $.get(`${SEC_INBOX_REQ_PATH}/${inbox}/unread-count`))).done((...results) => {
      const unreadCount = inboxes.length > 1 ? results.reduce((a, b) => a + b[0], 0) : results[0];
      if (unreadCount > 0) inboxBadge.addClass(NOTIFICATION_CLASS);
    });
  });
};

export const loadBadges = (): void => {
  if (PORTAL_BANNER.length === 0) {
    return;
  }

  const documentBadge = $('.notification-document');
  const inboxBadge = $('.notification-notifications');

  if (documentBadge.length !== 0) {
    checkDocumentNotif(documentBadge);
  }

  if (inboxBadge.length !== 0) {
    checkInboxNotif(inboxBadge);
  }
};
